export const getInputClasses = (className, { disabled, hayError, hayWarning } = {}) => {
  const classes = []
  if (className) classes.push(className)
  if (disabled) classes.push('disabled')
  if (hayError) classes.push('error')
  if (hayWarning) classes.push('warning')
  return classes.join(' ')
}
